import React from "react";
import RadioButton from "./RadioButton";
import SuccessIcon from "assets/svg/SuccessIcon";
import { Accordion as AccordionMui } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";

const Accordion = ({
  title,
  subTitle,
  label,
  options,
  handleChange,
  value,
  radioButtonClass,
  expanded,
  optionSelection,
  isFarm = false,
  data = {}
}) => {
  return (
    <AccordionMui expanded={expanded} onChange={handleChange(data?.id)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>
          <span className="radiobtn_custom">
            <SuccessIcon />
          </span>
          {title} <span>{subTitle && subTitle !== "" ? "(" + subTitle + ")" : '(non déterminé)'}</span>{" "}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          <RadioButton
            handleChange={optionSelection}
            value={value}
            options={options}
            formTitle={label}
            isFarm={isFarm}
            radioButtonClass={radioButtonClass}
          />
        </Typography>
      </AccordionDetails>
    </AccordionMui>
  );
};

export const AccordionType2 = ({
  title,
  subTitle,
  expanded,
  handleChange,
  data = {},
  detailLabel
}) => {
  return (
    <AccordionMui expanded={expanded} onChange={handleChange(data?.id)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>
          <span className="radiobtn_custom">
            <SuccessIcon />
          </span>
          {title} <span>{subTitle && subTitle !== "" ? "(" + subTitle + ")" : 'choisi'}</span>{" "}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          {
            detailLabel
          }
        </Typography>
      </AccordionDetails>
    </AccordionMui>
  );
};

export default Accordion;
